import RegItem from './reg-item'

export default RegItem
